import { render, staticRenderFns } from "./RptPoliceReport.vue?vue&type=template&id=de47c4bc&scoped=true&"
import script from "./RptPoliceReport.vue?vue&type=script&lang=js&"
export * from "./RptPoliceReport.vue?vue&type=script&lang=js&"
import style0 from "./RptPoliceReport.vue?vue&type=style&index=0&id=de47c4bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de47c4bc",
  null
  
)

export default component.exports